<div
  class="navbar-top"
  style="padding: 0px; margin: 0px"
  [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
>
  <div class="logo">
    <img
      class="logo-gt2"
      src="assets/images/logos/{{ 'APP.LOGO' | translate }}"
    />
    <!-- <span style="color: #ffffffb3" class="logo-text">{{
      "APP.TITLE" | translate
    }}</span> -->
  </div>

  <div class="buttons">
    <button
      mat-icon-button
      class="toggle-sidebar-folded fx-hide-lt-lg"
      (click)="toggleSidebarFolded()"
    >
      <mat-icon style="color: #ffffffb3">menu</mat-icon>
    </button>

    <button
      mat-icon-button
      class="toggle-sidebar-opened fx-hide-gt-md"
      (click)="toggleSidebarOpened()"
    >
      <mat-icon style="color: #ffffffb3">arrow_back</mat-icon>
    </button>
  </div>
</div>

<div
  *ngIf="organization"
  class="navbar-scroll-container"
  [ngClass]="fuseConfig.layout.navbar.primaryBackground"
  fusePerfectScrollbar
  [fusePerfectScrollbarOptions]="{ suppressScrollX: true }"
>
  <div
    class="user cursor-pointer flex-column"
    (click)="navigateToDashboard()"
    [ngClass]="fuseConfig.layout.navbar.secondaryBackground"
    style="padding-top: 0px;"
  >
    <div class="avatar-container">
      <img
        class="avatar-gt2"
        onerror="if (this.src !== '/assets/images/logos/default-no-org-logo.png') {this.src='/assets/images/logos/default-no-org-logo.png';}"
        src="{{ organization.data.logo }}"
      />
    </div>
    <!--<div class="h4 username">{{organization.data.name}}</div>-->
  </div>

  <div *ngxPermissionsOnly="['GOD']" class="org-select">
    <mat-select
      *ngIf="organizations && organizations.length > 1"
      class="primary px-8 py-8 my-4"
      matTooltip="{{ 'GENERIC.SELECT_CATERER' | translate }}"
      placeholder="{{ 'GENERIC.ORGANIZATIONS' | translate }}"
      (selectionChange)="onSelectionChange($event)"
      [(ngModel)]="selectedOrganization"
    >
      <mat-option *ngFor="let item of organizations" [value]="item">{{
        item.name
      }}</mat-option>
    </mat-select>
  </div>

  <div class="navbar-content">
    <fuse-navigation layout="vertical"></fuse-navigation>
  </div>
</div>

<div class="navbar-footer" [ngClass]="fuseConfig?.layout?.navbar?.primaryBackground">
  <button
    *ngIf="pwa.canInstall()"
    type="button"
    mat-stroked-button
    class="navbar-footer__install-btn"
    (click)="onInstallClick()"
  >
    <span>{{ "PWA.INSTALL_APP" | translate }}</span>
  </button>

  <div class="navbar-footer__socials">
    <a
      href="{{ facebookURL }}"
      target="_blank"
      rel="noopener"
      class="navbar-footer__social"
      aria-label="Facebook"
    >
      <mat-icon fontSet="fab" fontIcon="fa-facebook" class="navbar-footer__social-icon"></mat-icon>
    </a>

    <a
      href="{{ linkedInURL }}"
      target="_blank"
      rel="noopener"
      class="navbar-footer__social"
      aria-label="LinkedIn"
    >
      <mat-icon fontSet="fab" fontIcon="fa-linkedin" class="navbar-footer__social-icon"></mat-icon>
    </a>

    <a
      href="{{ instagramURL }}"
      target="_blank"
      rel="noopener"
      class="navbar-footer__social"
      aria-label="Instagram"
    >
      <mat-icon fontSet="fab" fontIcon="fa-instagram" class="navbar-footer__social-icon"></mat-icon>
    </a>
  </div>

  <p class="navbar-footer__copyright">
    © {{ currentYear }} {{ "APP.TITLE" | translate }}
  </p>
</div>
